/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination + pre-load listing pages to a cap so
   client-side filter/sort/"Other" see the whole section (Batch 2). */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination(true, undefined, false, 100);
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Custom Navigation Icons API & Auto-Injection */
(function () {
    var icons = typeof navigationIcons !== 'undefined' ? navigationIcons : {};
    var pendingIcons = new Map();
    var initialized = false;

    function getIcon(slug) {
        if (!slug) return icons.default;
        var icon = icons[slug.toLowerCase()];
        if (typeof icon === 'function') {
            return icon.call(icons);
        }
        return icon || icons.default;
    }

    function applyIcons() {
        document.querySelectorAll('.gh-navigation-menu .nav li, .gh-head-menu .nav li').forEach(function(li) {
            var slug = Array.from(li.classList)
                .find(function(cls) {
                    return cls.startsWith('nav-') && cls !== 'nav-item' && cls !== 'nav-current';
                })
                ?.replace('nav-', '');
            if (slug) {
                var iconContainer = li.querySelector('.nav-icon');
                if (iconContainer) {
                    iconContainer.innerHTML = getIcon(slug);
                }
            }
        });
    }

    window.navIcons = {
        setIcon: function(slug, svgContent) {
            if (!slug || typeof svgContent !== 'string') return;
            icons[slug.toLowerCase()] = svgContent;
            if (initialized) {
                applyIcons();
            }
        },
        getIcon: getIcon,
        applyIcons: applyIcons
    };

    document.addEventListener('DOMContentLoaded', function() {
        initialized = true;
        applyIcons();
    });
})();

/* Hide Portal Powered By Ghost Badge (MutationObserver) */
(function () {
    window.addEventListener('load', function() {
        var ghostPortal = document.getElementById('ghost-portal-root');
        if (!ghostPortal) return;
        
        var ghostPortalWrapper = null;
        var ghostPoweredFinder = null;

        var findandRemoveGhostPowered = function() {
            if (!ghostPortalWrapper || !ghostPortalWrapper.firstChild || !ghostPortalWrapper.firstChild.contentDocument) return;
            var ghostPowered = ghostPortalWrapper.firstChild.contentDocument.body.querySelector('.gh-portal-powered');
            if (ghostPowered != null) {
                ghostPowered.style.display = 'none';
                clearInterval(ghostPoweredFinder);
            }
        };

        var portalObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes[0]?.nodeName === 'DIV') {
                    ghostPortalWrapper = mutation.addedNodes[0];
                    ghostPoweredFinder = setInterval(findandRemoveGhostPowered, 50);             
                }
            });         
        });

        portalObserver.observe(ghostPortal, {
            attributes: false,
            characterData: true,
            childList: true,
            subtree: true,
            attributeOldValue: false,
            characterDataOldValue: true
        });
    });
})();

/* Tone Toggle behavior */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        var toggleButtons = document.querySelectorAll('.gh-tone-toggle');
        toggleButtons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                // Glass is dark-only for now (light mode built but hidden): ignore tone
                // toggles while it's active. Checked at CLICK time (not page load) so the toggle
                // re-enables the moment the visitor switches to another skin without a reload.
                if (document.documentElement.getAttribute('data-skin') === 'glass') { return; }
                var currentTone = document.documentElement.getAttribute('data-tone');
                var newTone = currentTone === 'dark' ? 'light' : 'dark';
                
                document.documentElement.setAttribute('data-tone', newTone);
                if (newTone === 'dark') {
                    document.documentElement.classList.remove('has-dark-text');
                    document.documentElement.classList.add('has-light-text');
                } else {
                    document.documentElement.classList.remove('has-light-text');
                    document.documentElement.classList.add('has-dark-text');
                }
                
                localStorage.setItem('theme-tone', newTone);
            });
        });
    });
})();

/* The one panel (build step 6, spec §7): the skin button opens ONE panel holding skin,
   colour and type; tone stays its own button. Hover previews an option after a short pause
   (§9.5 trap 2: a sweep must not flash through every option); leaving the panel reverts;
   a click keeps; Esc or a click outside reverts and closes; a touch screen has no hover, so
   a tap keeps. Two instances (desktop sidebar + phone top bar) share one committed state,
   exactly as the old skin menu did. The panel is site UI, so a previewed look would repaint
   it too: its sizes are fixed px in the stylesheet, and paint() below writes its colours and
   face onto it as LITERALS read from the page at the kept look, so a preview that repaints
   the page never moves the tile under the pointer (§7 trap 1). Keeps persist through
   localStorage (theme-skin/-tone/-color/-era), restored pre-paint by default.hbs. */
(function() {
    var VALID = ['curtain','paper','canvas','glass'];
    var VALID_ERAS = ['old','mid','modern'];
    document.addEventListener('DOMContentLoaded', function() {
        var root = document.documentElement;
        var insts = [];
        Array.prototype.forEach.call(document.querySelectorAll('.gh-skin-switcher'), function(el) {
            var btn = el.querySelector('.gh-skin-button');
            var panel = el.querySelector('.gh-panel');
            if (btn && panel) { insts.push({ el: el, btn: btn, panel: panel, desktop: !el.closest('.gh-navigation-brand-actions') }); }
        });
        if (!insts.length) return;

        /* The committed look. The <html> attributes are already the visitor's restored
           choices (default.hbs runs pre-paint), so they are the one source to read. */
        function attrOr(name, valid, fallback) {
            var v = root.getAttribute(name);
            return valid.indexOf(v) !== -1 ? v : fallback;
        }
        var colourIds = Array.prototype.map.call(insts[0].panel.querySelectorAll('.gh-panel-chip'), function(b) {
            return b.getAttribute('data-colour-option');
        });
        var kept = {
            skin: attrOr('data-skin', VALID, 'canvas'),
            tone: root.getAttribute('data-tone') === 'dark' ? 'dark' : 'light',
            colour: attrOr('data-color', colourIds, 'green'),
            era: attrOr('data-era', VALID_ERAS, 'modern')
        };
        // Remember the visitor's last non-Glass light/dark choice in its own key so
        // leaving Glass (which forces dark and overwrites theme-tone) can restore it
        // even across page reloads.
        var savedPreTone = null;
        try { savedPreTone = localStorage.getItem('theme-tone-preglass'); } catch (e0) {}
        var toneBeforeGlass = (savedPreTone === 'dark' || savedPreTone === 'light') ? savedPreTone : kept.tone;
        var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
        var preview = null;   // the patched look while a hover holds, else null
        var hoverT = null;    // the 90ms hover delay timer
        var prefetched = {};  // skins whose era faces were announced this page

        function syncCardHover(skin) {
            // card-hover-sheen is a Curtain-only hover effect. The marker lives on <html>
            // (set pre-paint by the anti-FOUC script in default.hbs); keep it on the same
            // element here so a live skin-switch stays consistent with the initial paint.
            document.documentElement.classList.toggle('card-hover-sheen', skin === 'curtain');
        }
        function applyLook(look) {
            root.setAttribute('data-skin', look.skin);
            var effTone = look.skin === 'glass' ? 'dark' : look.tone;
            root.setAttribute('data-tone', effTone);
            root.classList.remove('has-light-text', 'has-dark-text');
            root.classList.add(effTone === 'dark' ? 'has-light-text' : 'has-dark-text');
            root.setAttribute('data-era', look.era);
            root.setAttribute('data-color', look.colour);
            syncCardHover(look.skin);
        }
        function colourAllowed() { return kept.skin === 'curtain' || kept.skin === 'paper'; }
        function skinLabel(id) {
            var el = insts[0].panel.querySelector('.gh-panel-skin[data-skin-option="' + id + '"] span:last-child');
            return el ? el.textContent : id;
        }
        function whyText() {
            /* names the colour pointed at or kept; in Canvas and Glass, the one-line reason (§7) */
            if (!colourAllowed()) return skinLabel(kept.skin) + ' uses its own colours.';
            var c = (preview && preview.colour) ? preview.colour : kept.colour;
            var chip = insts[0].panel.querySelector('.gh-panel-chip[data-colour-option="' + c + '"]');
            return chip ? chip.getAttribute('aria-label') : '';
        }
        function refreshWhy() {
            var t = whyText();
            insts.forEach(function(inst) { inst.panel.querySelector('.gh-panel-why').textContent = t; });
        }
        function eraStack(era) {
            return getComputedStyle(root).getPropertyValue('--era-' + era).trim();
        }
        /* Paint the panel from the page as it is NOW — only ever called with the kept look
           applied. The values land on the element as literals (§7 trap 1). */
        function paint() {
            var probe = document.createElement('span');
            probe.style.cssText = 'position:absolute;left:-99px;top:-99px;visibility:hidden';
            document.body.appendChild(probe);
            function tok(v) { probe.style.color = 'var(' + v + ')'; return getComputedStyle(probe).color; }
            var vals = {
                '--panel-line': tok('--color-border'),
                '--panel-ink': tok('--color-text-primary'),
                '--panel-muted': tok('--color-text-secondary'),
                '--panel-el': tok('--color-surface-element'),
                '--panel-bg': tok('--color-surface-nav'),
                '--panel-font': eraStack(kept.era) || 'inherit'
            };
            probe.remove();
            var allowed = colourAllowed();
            insts.forEach(function(inst) {
                for (var k in vals) inst.panel.style.setProperty(k, vals[k]);
                Array.prototype.forEach.call(inst.panel.querySelectorAll('.gh-panel-skin'), function(b) {
                    b.setAttribute('aria-checked', String(b.getAttribute('data-skin-option') === kept.skin));
                });
                inst.panel.querySelector('.gh-panel-chips').classList.toggle('gh-panel-chips-off', !allowed);
                Array.prototype.forEach.call(inst.panel.querySelectorAll('.gh-panel-chip'), function(b) {
                    b.setAttribute('aria-checked', String(b.getAttribute('data-colour-option') === kept.colour));
                    b.setAttribute('aria-disabled', String(!allowed));
                });
                Array.prototype.forEach.call(inst.panel.querySelectorAll('.gh-panel-era'), function(b) {
                    b.setAttribute('aria-checked', String(b.getAttribute('data-era-option') === kept.era));
                });
            });
            paintTiles();
            refreshWhy();
        }
        /* The three Aa tiles draw each era's face for the skin the page is WEARING right now —
           the kept skin normally, the hovered skin during a skin preview (owner, S76: show the
           type options without needing a click). Reads the computed --era-* values, so it works
           for whichever skin applyLook just applied. The tiles' boxes are fixed, so a glyph
           changing face moves nothing (§7 trap 1 holds). */
        function paintTiles() {
            insts.forEach(function(inst) {
                Array.prototype.forEach.call(inst.panel.querySelectorAll('.gh-panel-era'), function(b) {
                    var stack = eraStack(b.getAttribute('data-era-option'));
                    b.querySelector('.gh-panel-aa').style.fontFamily = stack;
                });
            });
        }
        function showCommitted() {
            clearTimeout(hoverT);
            preview = null;
            applyLook(kept);
            paintTiles();
            refreshWhy();
        }
        /* §9.5 trap 2: announce the current skin's era faces the moment the panel opens,
           so an era hover previews a face that is already on its way (or here). The map
           comes from default.hbs, which owns the cache-busted URLs; `announced` carries
           what the pre-paint script already asked for, so nothing is announced twice. */
        function prefetchEraFaces(skin) {
            var M = window.RohitEraFonts;
            if (!M || !M.FACE || !M.FILE || prefetched[skin]) return;
            prefetched[skin] = true;
            M.announced = M.announced || [];
            VALID_ERAS.forEach(function(era) {
                var face = (M.FACE[skin] || {})[era];
                var href = face && M.FILE[face];
                if (!href || M.announced.indexOf(href) !== -1) return;
                try {
                    var link = document.createElement('link');
                    link.rel = 'preload'; link.as = 'font'; link.type = 'font/woff2';
                    link.crossOrigin = 'anonymous'; link.href = href;
                    document.head.appendChild(link);
                    M.announced.push(href);
                } catch (e1) {}
            });
        }
        function openInst(inst) {
            showCommitted();   // drop any in-flight preview before (re)opening
            closeAll();        // only one panel open at a time
            paint();
            inst.panel.hidden = false;
            inst.btn.setAttribute('aria-expanded', 'true');
            if (inst.desktop) { document.body.classList.add('panel-open'); }
            prefetchEraFaces(kept.skin);
        }
        function closeInst(inst) { inst.panel.hidden = true; inst.btn.setAttribute('aria-expanded', 'false'); }
        function closeAll() { insts.forEach(closeInst); document.body.classList.remove('panel-open'); }
        function anyOpen() { return insts.some(function(i) { return !i.panel.hidden; }); }
        function clickedInsideAny(t) { return insts.some(function(i) { return i.el.contains(t); }); }

        function tryOn(patch) {
            clearTimeout(hoverT);
            hoverT = setTimeout(function() {
                var next = { skin: kept.skin, tone: kept.tone, colour: kept.colour, era: kept.era };
                for (var q in patch) next[q] = patch[q];
                preview = next;
                applyLook(next);
                if (patch.skin) { paintTiles(); prefetchEraFaces(patch.skin); }
                refreshWhy();
            }, 90);
        }
        function revert() { clearTimeout(hoverT); if (!preview) return; preview = null; applyLook(kept); paintTiles(); refreshWhy(); }
        function keep(patch) {
            clearTimeout(hoverT);
            preview = null;
            var wasGlass = kept.skin === 'glass';
            for (var q in patch) kept[q] = patch[q];
            if (patch.skin) {
                if (patch.skin === 'glass') {
                    if (!wasGlass) { toneBeforeGlass = kept.tone; } // remember the pre-Glass tone
                    kept.tone = 'dark';
                } else if (wasGlass) {
                    kept.tone = toneBeforeGlass; // leaving Glass: restore the remembered tone
                }
                if (anyOpen()) { prefetchEraFaces(kept.skin); }
            }
            try {
                localStorage.setItem('theme-skin', kept.skin);
                localStorage.setItem('theme-tone', kept.tone);
                localStorage.setItem('theme-tone-preglass', toneBeforeGlass);
                localStorage.setItem('theme-color', kept.colour);
                localStorage.setItem('theme-era', kept.era);
            } catch (e2) {}
            applyLook(kept);
            paint();
        }

        insts.forEach(function(inst) {
            inst.btn.addEventListener('click', function(e) {
                e.preventDefault(); e.stopPropagation();
                var wasOpen = !inst.panel.hidden;
                if (wasOpen) { showCommitted(); closeAll(); } else { openInst(inst); }
            });
            function option(sel, patchOf, guard) {
                Array.prototype.forEach.call(inst.panel.querySelectorAll(sel), function(opt) {
                    if (canHover) {
                        opt.addEventListener('mouseenter', function() {
                            if (!guard || guard()) { tryOn(patchOf(opt)); }
                        });
                    }
                    opt.addEventListener('click', function(e) {
                        e.preventDefault(); e.stopPropagation();
                        if (!guard || guard()) { keep(patchOf(opt)); }
                    });
                });
            }
            option('.gh-panel-skin', function(o) { return { skin: o.getAttribute('data-skin-option') }; });
            option('.gh-panel-era', function(o) { return { era: o.getAttribute('data-era-option') }; });
            option('.gh-panel-chip', function(o) { return { colour: o.getAttribute('data-colour-option') }; }, colourAllowed);
            // Leaving the panel (hover devices) reverts any preview; the panel stays open.
            inst.panel.addEventListener('mouseleave', function() { if (!inst.panel.hidden) revert(); });
        });

        // Click-outside / Esc revert and close. Button and option handlers stopPropagation,
        // so their own clicks never reach this listener.
        document.addEventListener('click', function(e) {
            if (!anyOpen() || clickedInsideAny(e.target)) { return; }
            // Owner, S76: the tone button stays usable while the panel is open — the one
            // outside control the outside-click rule ignores (the sync listener below
            // repaints the open panel for the new tone).
            if (e.target.closest && e.target.closest('.gh-tone-toggle')) { return; }
            showCommitted(); closeAll();
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && anyOpen()) { showCommitted(); closeAll(); }
        });

        // Keep kept.tone in sync when the visitor uses the tone toggle. The EXISTING tone
        // IIFE is registered first, so by the time this runs data-tone already holds the
        // NEW value — read it, do not flip it again. The panel repaints (its literals
        // follow the page's tone) whether it is open or shut — paint() is cheap.
        Array.prototype.forEach.call(document.querySelectorAll('.gh-tone-toggle'), function(toneBtn) {
            toneBtn.addEventListener('click', function() {
                if (kept.skin === 'glass') return;
                kept.tone = root.getAttribute('data-tone') === 'dark' ? 'dark' : 'light';
                toneBeforeGlass = kept.tone;
                try { localStorage.setItem('theme-tone-preglass', kept.tone); } catch (e3) {}
                paint();
            });
        });

        paint(); // aria state + tile faces reflect the restored look before the first open
    });
})();

/* Post content enrichments (tooltips, image-on-hover, footnotes, TOC) */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        if (typeof initPostEnrichments === 'function') { initPostEnrichments(); }
    });
})();

/* Parse navigation group headers starting with #.
   Two markers, typed into the Ghost admin nav LABEL field:
     `#Label`   → section header, NOT clickable (the href is discarded)
     `#>Label`  → section header, clickable (keeps whatever URL the item holds)
   Ghost's slugify drops both `#` and `>`, so the marker never changes the
   `nav-<slug>` class and therefore never changes which icon fires (see R4).
   Both variants keep `nav-group-header`, so every existing header style —
   including the collapsed-rail icon chip — applies unchanged; the clickable
   variant only adds `nav-group-header-link` on top. */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        var navItems = document.querySelectorAll('.sidebar-overlay #gh-navigation .nav li');
        navItems.forEach(function(item) {
            var anchor = item.querySelector('a');
            var span = item.querySelector('span');
            if (anchor && span) {
                var text = span.textContent.trim();
                if (text.startsWith('#')) {
                    var isLink = text.charAt(1) === '>';
                    item.classList.add('nav-group-header');
                    span.textContent = text.substring(isLink ? 2 : 1).trim().toUpperCase();
                    if (isLink) {
                        item.classList.add('nav-group-header-link');
                    } else {
                        anchor.removeAttribute('href');
                        anchor.style.pointerEvents = 'none';
                        anchor.style.cursor = 'default';
                    }
                }
            }
        });
    });
})();
